/*
 * The behavior plugin essentially attaches handler methods to DOM nodes that may then be triggered and the return values
 * are collected and passed back as an array. This plugin also bubbles or propagates the behavior request allowing for 
 * implementation of behaviors through delegation.
 */
(function($) {
	/*
	 * The main behavior method for binding a callback to a DOM element (works similar in concept to .bind())
	 */
	$.fn.behavior = function( name, behave ) {
		if ( arguments.length < 2  //validate the input
				|| name == null 
				|| $.isFunction( name ) ) {
			return this;
		}
		return this.each(function() {
						var behaviors = $(this).data('behaviors') || { };
						behaviors[ name.toLowerCase() ] = behave;
						$(this).data('behaviors', behaviors);
					});
	};
	
	/*
	 * Removes a given behavior from an element.
	 */
	$.fn.removeBehavior = function( name ) {
		return this.each(function() {
						if( arguments.length == 0 ) {
							$(this).removeData('behaviors');
						} else {
							var behaviors = $(this).data('behaviors') || { };
							delete behaviors[ name.toLowerCase() ];
						}
					});
	};
	
	/*
	 * Returns the behaviors bound to an element
	 */
	$.fn.listBehaviors = function() {
		var ret = [];
		var behaviors = $(this).eq(0).data('behaviors') || { };
		$.each(behaviors, function(key, val) {
			ret.push(key);
		});
		return ret;
	};
	
	/*
	 * Executes a given behavior on an element (which executes the behavior callbacks bound to that element).
	 * If none exists on the current node, the search propagates up the DOM tree.
	 */
	$.fn.triggerBehavior = function( name, args, target ) {
		var ret = [];
		this.each(function() {
			var behaviors = $(this).data('behaviors') || { };
			// We have a behavior attached to this node, so process it (and not walk up the tree)
			if ( behaviors[ name.toLowerCase() ] ) {
				// Do we have an executable callback method?
				if ( $.isFunction( behaviors[ name.toLowerCase() ] ) ) {
					var _args = [ { type: name.toLowerCase(), target: target || this } ];
					if ( args ) {
						$.each(args, function(k, v) {
							_args.push( v );
						});
					}
					ret.push( behaviors[ name.toLowerCase() ].apply( this, _args ) );
				} else {
					// We don't have a callback function, we simply have a data value
					ret.push( behaviors[ name.toLowerCase() ] );
				}
			} else {
				// Walk up the tree looking for a behavior on a parent
				$(this).parents().each(function() {
					var tmp = $(this).triggerBehavior( name, args, this );
					if ( tmp.length == 1 ) {
						ret.push( tmp[0] );
						return false;
					}
				});
			}
		});
		return ret;
	};
})(jQuery);